export const bufferToBlobPdf = (buffer) => {
  return new Blob([buffer], { type: 'application/pdf' })
}
export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    let fileReader = new FileReader()
    fileReader.onload = (e) => {
      if (!e.target) {
        return reject(new Error('error-file-type'))
      }
      return resolve(String(e.target.result))
    }
    fileReader.onerror = reject
    fileReader.readAsDataURL(file)
  })
}
export const base64ToFileStream = (base64) => {
  return base64.split(',')[1]
}
export const downloadBase64 = (base64, fileName = 'example') => {
  const downloadLink = document.createElement('a')
  downloadLink.href = base64
  downloadLink.download = fileName
  downloadLink.click()
}
